import { LogType } from '../types/LogType';
const LogData = {
    fromException(functionName, e) {
        return {
            functionName: functionName,
            message: `Code: ${e.code}; Name: ${e.name}; Message: ${e.message}; Stack: ${e.stack}`,
            timestamp: new Date(),
            type: LogType.genericError
        };
    },
    fromResponse(functionName, response) {
        return {
            functionName: functionName,
            message: `Status: ${response.status}; StatusText: ${response.statusText}; Url: ${response.url}`,
            timestamp: new Date(),
            type: LogType.genericError
        };
    },
    fromComponentException(functionName, e, info) {
        return {
            functionName: functionName,
            message: `Code: ${e.code}; Name: ${e.name}; Message: ${e.message}; Stack: ${e.stack}; ComponentStack: ${info.componentStack}`,
            timestamp: new Date(),
            type: LogType.genericError
        };
    },
    fromMessage(functionName, message) {
        return {
            functionName: functionName,
            message: message,
            timestamp: new Date(),
            type: LogType.genericError
        };
    },
    badJsonResult(functionName) {
        return {
            functionName: functionName,
            message: 'JsonResult is empty',
            timestamp: new Date(),
            type: LogType.genericError
        };
    },
    layoutNoReady(functionName) {
        return {
            functionName: functionName,
            message: 'Layout was not ready.',
            timestamp: new Date(),
            type: LogType.genericError
        };
    },
    noPermissions(functionName) {
        return {
            functionName: functionName,
            message: 'Permissions object is null.',
            timestamp: new Date(),
            type: LogType.genericError
        };
    },
    noResources(functionName) {
        return {
            functionName: functionName,
            message: 'Resources object is null.',
            timestamp: new Date(),
            type: LogType.genericError
        };
    }
};
export default LogData;
